// Bilingual content for Emergent Food landing page
export const content = {
  it: {
    nav: {
      manifesto: "Manifesto",
      process: "Percorso",
      services: "Servizi",
      what_we_do: "Cosa produciamo",
      clients: "Clienti",
      certifications: "Certificazioni",
      configurator: "Configuratore",
      contact: "Parliamone",
    },
    hero: {
      overline: "Food Manufacturing as a Service — Europe",
      title_lines: [
        "Trasformiamo idee",
        "alimentari in prodotti",
        "pronti per il mercato.",
      ],
      subtitle:
        "Emergent Food è il partner produttivo europeo per startup food, brand D2C, catene e private label. Sviluppiamo. Industrializziamo. Produciamo. Confezioniamo.",
      cta_primary: "Inizia un progetto",
      cta_secondary: "Guarda il processo",
      stats: [
        { k: "Bollo CE", v: "Laboratorio certificato" },
        { k: "27", v: "Paesi serviti in UE" },
        { k: "72h", v: "Tempo medio primo prototipo" },
      ],
      scroll_hint: "scorri",
    },
    marquee_line:
      "FOOD MANUFACTURING AS A SERVICE  ·  CONTRACT MANUFACTURING  ·  PRIVATE LABEL  ·  INDUSTRIALIZZAZIONE  ·  R&D FOOD  ·  MADE IN EUROPE  ·  ",
    manifesto: {
      overline: "Manifesto",
      title: "Non siamo un laboratorio.",
      subtitle:
        "Siamo il reparto esterno di Ricerca, Sviluppo e Produzione dei brand alimentari più ambiziosi d'Europa.",
      chapters: [
        {
          n: "01",
          h: "Un'idea non è ancora un prodotto.",
          p: "La distanza tra intuizione e scaffale è fatta di ricette, food cost, industrializzazione, HACCP, packaging, logistica. Noi copriamo tutto il percorso.",
        },
        {
          n: "02",
          h: "La produzione è un servizio, non un edificio.",
          p: "FMaaS significa scala on-demand, trasparenza radicale e velocità da software. Un partner, non un fornitore.",
        },
        {
          n: "03",
          h: "Diciamo no più spesso di quanto diciamo sì.",
          p: "Non lavoriamo pesce, molluschi, crostacei o ingredienti ittici. Lo diciamo prima. La chiarezza è il nostro primo servizio.",
        },
        {
          n: "04",
          h: "Il tempo del cliente vale più del nostro.",
          p: "Prototipi in giorni, non in mesi. Lotti pilota in settimane. Scala in Europa senza cambiare partner.",
        },
      ],
    },
    journey: {
      overline: "Il percorso",
      title: "Da un'idea, a uno scaffale in Europa.",
      subtitle: "Un unico partner. Sette passaggi. Zero handoff persi.",
      steps: [
        { n: "01", t: "Idea", d: "Brief strategico, benchmark, positioning, food cost preliminare." },
        { n: "02", t: "Ricetta", d: "R&D culinario, sensory panel, dichiarazione ingredienti conforme UE." },
        { n: "03", t: "Prototipo", d: "Campioni fisici in giorni, iterazione rapida, matching sensoriale." },
        { n: "04", t: "Lotto pilota", d: "Batch industrializzato, shelf-life test, documentazione HACCP." },
        { n: "05", t: "Produzione", d: "Manifattura in laboratorio Bollo CE. Tracciabilità completa." },
        { n: "06", t: "Scala", d: "Volumi crescenti senza cambiare specifica, senza cambiare fornitore." },
        { n: "07", t: "Mercato", d: "Packaging, etichettatura multilingua, logistica europea." },
      ],
    },
    services: {
      overline: "Servizi",
      title: "Un unico stack.",
      subtitle: "Nove capacità integrate. Un solo interlocutore.",
      items: [
        { t: "Product Development", d: "Dal brief alla ricetta industriale, con food designer e tecnologi alimentari.", span: "lg:col-span-7" },
        { t: "Food Cost", d: "Modellazione trasparente del costo per porzione, per lotto, per mercato.", span: "lg:col-span-5" },
        { t: "Industrializzazione", d: "Riformulazione per la scala. HACCP, shelf-life, tolleranze di processo.", span: "lg:col-span-5" },
        { t: "Pilot Batch", d: "Lotti pilota rapidi per validazione commerciale e sensoriale.", span: "lg:col-span-7" },
        { t: "Contract Manufacturing", d: "Produzione conto terzi con certificazione CE. MOQ scalabili.", span: "lg:col-span-6" },
        { t: "Private Label", d: "Linee dedicate al retailer, con branding e formulazione riservata.", span: "lg:col-span-6" },
        { t: "Packaging", d: "Sourcing, formato, sostenibilità, etichettatura conforme UE 1169/2011.", span: "lg:col-span-4" },
        { t: "Scale Production", d: "Volumi crescenti mantenendo specifica, resa, food cost.", span: "lg:col-span-4" },
        { t: "Logistics", d: "Distribuzione refrigerata e ambient in tutta Europa.", span: "lg:col-span-4" },
      ],
    },
    make: {
      overline: "Categorie",
      title: "Cosa produciamo.",
      subtitle: "Otto categorie ad alto valore, tutte industrializzabili nel nostro laboratorio Bollo CE.",
      list: [
        { t: "Carne", d: "Cotture lente, marinature, porzionati." },
        { t: "Verdure", d: "Preparazioni fresche, grigliate, arrostite." },
        { t: "Salse", d: "Emulsioni, riduzioni, salse madri, condimenti." },
        { t: "Brodi", d: "Chiari, tostati, vegetali, di carne, concentrati." },
        { t: "Fondi", d: "Bruni, chiari, riduzioni ad alta densità." },
        { t: "Basi", d: "Basi neutre e aromatizzate per catene e industria." },
        { t: "Semilavorati", d: "Componenti pronti all'assemblaggio, ricette proprietarie." },
        { t: "Piatti pronti", d: "Ready meal refrigerati e ambient, mono e multi-porzione." },
      ],
    },
    dontmake: {
      overline: "Trasparenza radicale",
      title: "Cosa non facciamo.",
      subtitle:
        "Il nostro laboratorio è ittico-free per scelta. Nessuna cross-contaminazione, nessun compromesso sulle allergie, nessun tempo perso a chiedere.",
      list: [
        "Pesce",
        "Molluschi",
        "Crostacei",
        "Salsa di pesce",
        "Dashi di pesce",
        "Bonito",
        "Acciughe",
        "Estratti ittici",
      ],
      note: "Se il tuo prodotto contiene ingredienti ittici, non siamo il partner giusto. È una promessa che manteniamo.",
    },
    trust: {
      overline: "Clienti",
      title: "Brand che hanno scelto Emergent.",
      subtitle:
        "Concept ambiziosi, standard alti, tempi da startup. Ecco il tipo di partner con cui lavoriamo.",
      cases: [
        {
          name: "Donburi House",
          category: "Fast-casual chain · Multi-city",
          quote:
            "Ogni bowl esce identica a Milano, Berlino e Parigi. Industrializzazione senza perdere l'anima del piatto.",
          image:
            "https://customer-assets-lxgj4vgw.emergentagent.net/job_fmaas-hub/artifacts/dnq2m1kj_DONBURI%202.webp",
        },
      ],
    },
    configurator: {
      overline: "Configura il tuo progetto",
      title: "Dalla tua idea al mercato.",
      subtitle:
        "Quattro passaggi. Nessun impegno. Un lead qualificato ricevuto dal nostro team di R&D entro 24 ore.",
      steps: [
        {
          key: "project_type",
          label: "Che tipo di progetto è?",
          options: [
            { v: "startup", l: "Startup food / D2C" },
            { v: "brand", l: "Brand esistente" },
            { v: "chain", l: "Catena / franchising" },
            { v: "retail", l: "Retail / private label" },
            { v: "horeca", l: "Ho.Re.Ca. / distributore" },
          ],
        },
        {
          key: "product_category",
          label: "Su cosa stai lavorando?",
          options: [
            { v: "ready_meal", l: "Piatto pronto" },
            { v: "sauce", l: "Salsa / condimento" },
            { v: "broth", l: "Brodo / fondo" },
            { v: "meat", l: "Carne preparata" },
            { v: "vegetable", l: "Verdure / basi vegetali" },
            { v: "semi", l: "Semilavorato per B2B" },
            { v: "other", l: "Altro" },
          ],
        },
        {
          key: "volume",
          label: "Volume iniziale atteso (unità/mese)",
          options: [
            { v: "0-1k", l: "0 – 1.000" },
            { v: "1-10k", l: "1.000 – 10.000" },
            { v: "10-50k", l: "10.000 – 50.000" },
            { v: "50k+", l: "50.000+" },
            { v: "unsure", l: "Non ancora definito" },
          ],
        },
        {
          key: "timeline",
          label: "Quando vuoi essere sul mercato?",
          options: [
            { v: "<3m", l: "Meno di 3 mesi" },
            { v: "3-6m", l: "3 – 6 mesi" },
            { v: "6-12m", l: "6 – 12 mesi" },
            { v: "12m+", l: "Oltre 12 mesi" },
          ],
        },
      ],
      form: {
        title: "Ultimi dettagli",
        subtitle: "Riceverai una risposta dal nostro team entro 24 ore lavorative.",
        fields: {
          company: "Azienda",
          name: "Nome e cognome",
          email: "Email di lavoro",
          role: "Ruolo",
          country: "Paese",
          message: "Descrivi brevemente il tuo progetto",
        },
        submit: "Invia richiesta",
        submitting: "Invio in corso…",
        success: "Ricevuto. Ti scriviamo entro 24 ore.",
        error: "Qualcosa è andato storto. Riprova.",
      },
      restrictedTitle: "Attenzione",
      restrictedText:
        "Non lavoriamo prodotti ittici (pesce, molluschi, crostacei, salse a base di pesce). Se il tuo prodotto ne contiene, non siamo il partner giusto.",
      next: "Continua",
      back: "Indietro",
    },
    faq: {
      overline: "Domande frequenti",
      title: "Prima che tu chieda.",
      items: [
        {
          q: "Qual è il MOQ minimo?",
          a: "Dipende dalla categoria: dai 500 pezzi per un lotto pilota fino a decine di migliaia per la produzione a regime. Nessuna barriera d'ingresso rigida.",
        },
        {
          q: "Su quali paesi europei potete distribuire?",
          a: "Su tutti i 27 paesi UE. Il nostro laboratorio ha Bollo CE e produce con documentazione conforme UE 1169/2011.",
        },
        {
          q: "Le mie ricette sono protette?",
          a: "Sì. Firmiamo NDA prima del primo brief. Le formulazioni proprietarie restano di proprietà del cliente, senza eccezioni.",
        },
        {
          q: "Quanto tempo per un primo prototipo?",
          a: "In media 72 ore dal brief per un prototipo assaggiabile. Le iterazioni successive richiedono giorni, non settimane.",
        },
        {
          q: "Lavorate ingredienti ittici?",
          a: "No. Il nostro laboratorio è ittico-free per scelta. Nessun pesce, mollusco, crostaceo o estratto ittico entra in produzione.",
        },
        {
          q: "Che certificazioni avete?",
          a: "Bollo CE, HACCP, tracciabilità completa. Ulteriori certificazioni (BRC, IFS, biologico) su progetti dedicati.",
        },
      ],
    },
    footer: {
      cta_overline: "Parliamone",
      cta_title: "Hai un'idea. Noi la produciamo.",
      cta_sub: "24 ore per una prima risposta. Zero brochure.",
      cta_btn: "Inizia un progetto",
      legal: "© 2025 Emergent Food S.r.l. — Food Manufacturing as a Service.",
      links: ["Privacy", "Cookie", "Impressum"],
    },
    start: {
      overline: "Inizia un progetto",
      title_lines: ["Descrivi il tuo", "prodotto.", "Ti rispondiamo in 24 ore."],
      subtitle:
        "Un configuratore veloce, un brief qualificato, una risposta reale dal team R&D di Emergent Food. Nessuna call obbligatoria per iniziare.",
      close: "Chiudi",
      next_title: "Cosa succede dopo.",
      next_sub: "Un processo trasparente, con tempi certi. Nessuna zona grigia.",
      next_steps: [
        { n: "01", t: "Risposta in 24 ore", d: "Un product manager Emergent legge il tuo brief e ti risponde con osservazioni concrete, non un template." },
        { n: "02", t: "NDA firmato in 48 ore", d: "Prima di ricevere qualsiasi dettaglio sensibile, firmiamo un accordo di riservatezza reciproco." },
        { n: "03", t: "Primo prototipo in 72 ore", d: "Dal via libera al brief, il primo campione assaggiabile arriva entro tre giorni lavorativi." },
        { n: "04", t: "Scala in Europa", d: "Se andiamo avanti, produzione con Bollo CE e distribuzione in 27 mercati UE." },
      ],
      trust_overline: "Ci scelgono brand come",
      trust_more: "+ 40 brand alimentari in Europa",
      testimonial_overline: "— Testimonianza",
      testimonial_quote:
        "Ogni bowl esce identica a Milano, Berlino e Parigi. Emergent è il reparto industriale che, senza di loro, avremmo dovuto costruire in due anni.",
      testimonial_author: "Head of Operations, Donburi House",
      calendly_overline: "Salta la coda",
      calendly_title: "Preferisci parlare subito?",
      calendly_sub:
        "Prenota una call di 30 minuti con un product manager Emergent. Nessun impegno, nessuna presentazione. Solo il tuo problema e il nostro punto di vista.",
      calendly_cta: "Prenota una call",
      faq_overline: "Prima che tu chieda",
      faq_title: "Tre cose importanti.",
      faq_items: [
        { q: "Qual è il MOQ minimo?", a: "Da 500 pezzi per un lotto pilota fino a decine di migliaia a regime. Nessuna barriera d'ingresso rigida." },
        { q: "Lavorate ingredienti ittici?", a: "No. Il nostro laboratorio è ittico-free per scelta. Niente pesce, molluschi, crostacei o estratti ittici, in nessuna forma." },
        { q: "Le mie ricette sono protette?", a: "Sì. Firmiamo NDA reciproco prima del primo brief tecnico. Le formulazioni proprietarie restano al 100% del cliente." },
      ],
    },
  },
  en: {
    nav: {
      manifesto: "Manifesto",
      process: "Process",
      services: "Services",
      what_we_do: "What we make",
      clients: "Clients",
      certifications: "Certifications",
      configurator: "Configure",
      contact: "Start a project",
    },
    hero: {
      overline: "Food Manufacturing as a Service — Europe",
      title_lines: [
        "We turn food ideas",
        "into market-ready",
        "products.",
      ],
      subtitle:
        "Emergent Food is the European manufacturing partner for food startups, D2C brands, chains and private label. We develop. We industrialise. We produce. We ship.",
      cta_primary: "Start a project",
      cta_secondary: "See the process",
      stats: [
        { k: "CE-approved", v: "Certified facility" },
        { k: "27", v: "EU countries served" },
        { k: "72h", v: "Average first prototype" },
      ],
      scroll_hint: "scroll",
    },
    marquee_line:
      "FOOD MANUFACTURING AS A SERVICE  ·  CONTRACT MANUFACTURING  ·  PRIVATE LABEL  ·  INDUSTRIALISATION  ·  FOOD R&D  ·  MADE IN EUROPE  ·  ",
    manifesto: {
      overline: "Manifesto",
      title: "We are not a factory.",
      subtitle:
        "We are the external R&D, industrialisation and production team of Europe's most ambitious food brands.",
      chapters: [
        {
          n: "01",
          h: "An idea is not yet a product.",
          p: "The gap between insight and shelf is made of recipes, food cost, industrialisation, HACCP, packaging, logistics. We cover the entire path.",
        },
        {
          n: "02",
          h: "Manufacturing is a service, not a building.",
          p: "FMaaS means on-demand scale, radical transparency and software-speed. A partner, not a supplier.",
        },
        {
          n: "03",
          h: "We say no more often than we say yes.",
          p: "No fish, molluscs, crustaceans or seafood-derived ingredients. We say it upfront. Clarity is our first service.",
        },
        {
          n: "04",
          h: "Your time is worth more than ours.",
          p: "Prototypes in days. Pilot batches in weeks. Scale across Europe without switching partner.",
        },
      ],
    },
    journey: {
      overline: "The path",
      title: "From an idea, to a European shelf.",
      subtitle: "One partner. Seven steps. Zero lost handoffs.",
      steps: [
        { n: "01", t: "Idea", d: "Strategic brief, benchmarks, positioning, early food cost." },
        { n: "02", t: "Recipe", d: "Culinary R&D, sensory panel, EU-compliant ingredient statement." },
        { n: "03", t: "Prototype", d: "Physical samples in days. Rapid iteration, sensory matching." },
        { n: "04", t: "Pilot batch", d: "Industrialised batch, shelf-life tests, HACCP documentation." },
        { n: "05", t: "Production", d: "CE-approved manufacturing. Full traceability." },
        { n: "06", t: "Scale", d: "Growing volumes without changing specs or supplier." },
        { n: "07", t: "Market", d: "Packaging, multilingual labelling, European logistics." },
      ],
    },
    services: {
      overline: "Services",
      title: "One integrated stack.",
      subtitle: "Nine capabilities. One point of contact.",
      items: [
        { t: "Product Development", d: "From brief to industrial recipe, with food designers and technologists.", span: "lg:col-span-7" },
        { t: "Food Cost", d: "Transparent modelling per portion, per batch, per market.", span: "lg:col-span-5" },
        { t: "Industrialisation", d: "Reformulation for scale. HACCP, shelf-life, process tolerances.", span: "lg:col-span-5" },
        { t: "Pilot Batch", d: "Fast pilot batches for commercial and sensory validation.", span: "lg:col-span-7" },
        { t: "Contract Manufacturing", d: "CE-certified co-manufacturing. Scalable MOQs.", span: "lg:col-span-6" },
        { t: "Private Label", d: "Dedicated retailer lines with confidential formulation.", span: "lg:col-span-6" },
        { t: "Packaging", d: "Sourcing, format, sustainability, EU 1169/2011 labelling.", span: "lg:col-span-4" },
        { t: "Scale Production", d: "Volume growth without losing spec, yield or food cost.", span: "lg:col-span-4" },
        { t: "Logistics", d: "Refrigerated and ambient distribution across Europe.", span: "lg:col-span-4" },
      ],
    },
    make: {
      overline: "Categories",
      title: "What we make.",
      subtitle: "Eight high-value categories, all industrialisable in our CE-approved facility.",
      list: [
        { t: "Meat", d: "Slow-cooked, marinated, portioned." },
        { t: "Vegetables", d: "Fresh, grilled and roasted preparations." },
        { t: "Sauces", d: "Emulsions, reductions, mother sauces, dressings." },
        { t: "Broths", d: "Clear, roasted, vegetable, meat, concentrated." },
        { t: "Stocks", d: "Brown, white, high-density reductions." },
        { t: "Bases", d: "Neutral and flavoured bases for chains and industry." },
        { t: "Semi-finished", d: "Ready-to-assemble components, proprietary recipes." },
        { t: "Ready meals", d: "Chilled and ambient ready meals, single and multi-serve." },
      ],
    },
    dontmake: {
      overline: "Radical transparency",
      title: "What we don't do.",
      subtitle:
        "Our facility is seafood-free by design. No cross-contamination, no compromise on allergens, no wasted time.",
      list: [
        "Fish",
        "Molluscs",
        "Crustaceans",
        "Fish sauce",
        "Fish dashi",
        "Bonito",
        "Anchovies",
        "Seafood extracts",
      ],
      note: "If your product contains seafood ingredients, we're not the right partner. It's a promise we keep.",
    },
    trust: {
      overline: "Clients",
      title: "Brands that chose Emergent.",
      subtitle:
        "Ambitious concepts, high standards, startup timelines. The kind of partners we work with.",
      cases: [
        {
          name: "Donburi House",
          category: "Fast-casual chain · Multi-city",
          quote:
            "Every bowl leaves identical in Milan, Berlin and Paris. Industrialisation without losing the soul of the dish.",
          image:
            "https://customer-assets-lxgj4vgw.emergentagent.net/job_fmaas-hub/artifacts/dnq2m1kj_DONBURI%202.webp",
        },
      ],
    },
    configurator: {
      overline: "Configure your project",
      title: "From your idea to the market.",
      subtitle:
        "Four steps. No commitment. A qualified brief on our R&D team's desk within 24 hours.",
      steps: [
        {
          key: "project_type",
          label: "What kind of project is this?",
          options: [
            { v: "startup", l: "Food startup / D2C" },
            { v: "brand", l: "Existing brand" },
            { v: "chain", l: "Chain / franchise" },
            { v: "retail", l: "Retail / private label" },
            { v: "horeca", l: "Ho.Re.Ca. / distributor" },
          ],
        },
        {
          key: "product_category",
          label: "What are you working on?",
          options: [
            { v: "ready_meal", l: "Ready meal" },
            { v: "sauce", l: "Sauce / dressing" },
            { v: "broth", l: "Broth / stock" },
            { v: "meat", l: "Prepared meat" },
            { v: "vegetable", l: "Vegetables / plant bases" },
            { v: "semi", l: "B2B semi-finished" },
            { v: "other", l: "Other" },
          ],
        },
        {
          key: "volume",
          label: "Expected starting volume (units/month)",
          options: [
            { v: "0-1k", l: "0 – 1,000" },
            { v: "1-10k", l: "1,000 – 10,000" },
            { v: "10-50k", l: "10,000 – 50,000" },
            { v: "50k+", l: "50,000+" },
            { v: "unsure", l: "Not defined yet" },
          ],
        },
        {
          key: "timeline",
          label: "When do you want to hit the market?",
          options: [
            { v: "<3m", l: "Less than 3 months" },
            { v: "3-6m", l: "3 – 6 months" },
            { v: "6-12m", l: "6 – 12 months" },
            { v: "12m+", l: "More than 12 months" },
          ],
        },
      ],
      form: {
        title: "Final details",
        subtitle: "You'll hear back from our team within 24 business hours.",
        fields: {
          company: "Company",
          name: "Full name",
          email: "Work email",
          role: "Role",
          country: "Country",
          message: "Briefly describe your project",
        },
        submit: "Send request",
        submitting: "Sending…",
        success: "Received. We'll reply within 24 hours.",
        error: "Something went wrong. Please try again.",
      },
      restrictedTitle: "Please note",
      restrictedText:
        "We do not work with seafood (fish, molluscs, crustaceans, fish-based sauces). If your product contains any, we're not the right partner.",
      next: "Continue",
      back: "Back",
    },
    faq: {
      overline: "Frequently asked",
      title: "Before you ask.",
      items: [
        {
          q: "What's the minimum MOQ?",
          a: "It depends on the category: from 500 units for a pilot batch up to tens of thousands for full production. No rigid entry barrier.",
        },
        {
          q: "Which European markets can you serve?",
          a: "All 27 EU countries. Our facility is CE-approved and produces with EU 1169/2011-compliant documentation.",
        },
        {
          q: "Are my recipes protected?",
          a: "Yes. NDA signed before the first brief. Proprietary formulations remain the client's IP, no exceptions.",
        },
        {
          q: "How long for a first prototype?",
          a: "72 hours on average from the brief for a tasteable prototype. Iterations take days, not weeks.",
        },
        {
          q: "Do you work with seafood?",
          a: "No. Our facility is seafood-free by design. No fish, molluscs, crustaceans or seafood extracts enter production.",
        },
        {
          q: "What certifications do you hold?",
          a: "CE approval, HACCP, full traceability. Further certifications (BRC, IFS, organic) on dedicated projects.",
        },
      ],
    },
    footer: {
      cta_overline: "Let's talk",
      cta_title: "You have an idea. We produce it.",
      cta_sub: "24 hours to a first reply. Zero brochures.",
      cta_btn: "Start a project",
      legal: "© 2025 Emergent Food S.r.l. — Food Manufacturing as a Service.",
      links: ["Privacy", "Cookies", "Impressum"],
    },
    start: {
      overline: "Start a project",
      title_lines: ["Describe your", "product.", "We reply in 24 hours."],
      subtitle:
        "A short configurator, a qualified brief, a real reply from the Emergent Food R&D team. No mandatory call to get started.",
      close: "Close",
      next_title: "What happens next.",
      next_sub: "A transparent process with real timelines. No grey areas.",
      next_steps: [
        { n: "01", t: "Reply in 24 hours", d: "An Emergent product manager reads your brief and comes back with concrete observations, not a templated auto-reply." },
        { n: "02", t: "Mutual NDA in 48 hours", d: "Before you share any sensitive detail, we sign a mutual non-disclosure agreement." },
        { n: "03", t: "First prototype in 72 hours", d: "From brief sign-off, the first tasteable sample lands within three business days." },
        { n: "04", t: "Scale across Europe", d: "If we move forward: CE-approved manufacturing and distribution across 27 EU markets." },
      ],
      trust_overline: "Brands that chose Emergent",
      trust_more: "+ 40 food brands across Europe",
      testimonial_overline: "— Testimonial",
      testimonial_quote:
        "Every bowl leaves identical in Milan, Berlin and Paris. Emergent is the industrial partner we would have needed two years to build in-house.",
      testimonial_author: "Head of Operations, Donburi House",
      calendly_overline: "Skip the queue",
      calendly_title: "Prefer to talk right now?",
      calendly_sub:
        "Book a 30-minute call with an Emergent product manager. No commitment, no deck — just your problem and our point of view.",
      calendly_cta: "Book a call",
      faq_overline: "Before you ask",
      faq_title: "Three things that matter.",
      faq_items: [
        { q: "What's the minimum MOQ?", a: "From 500 units for a pilot batch to tens of thousands at full production. No rigid entry barrier." },
        { q: "Do you work with seafood?", a: "No. Our facility is seafood-free by design. No fish, molluscs, crustaceans or seafood extracts in any form." },
        { q: "Are my recipes protected?", a: "Yes. We sign a mutual NDA before the first technical brief. Proprietary formulations remain 100% the client's." },
      ],
    },
  },
};
